import { DeliveryAddress, NonNullableGenericState, SelectorUtil } from '@us/web/shared/data-access';
import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { DeliveryAddressesActions } from './delivery-address.actions';

export const DELIVERY_ADDRESS_FEATURE_KEY = 'deliveryAddress';

export type DeliveryAddressState = NonNullableGenericState<DeliveryAddress[]>;

export const initialDeliveryAddressState: DeliveryAddressState = {
    data: [],
    status: 'pending',
    error: null
};

const reducer = createReducer(
    initialDeliveryAddressState,
    on(
        DeliveryAddressesActions.loadDeliveryAddresses,
        (state): DeliveryAddressState => ({ ...state, status: 'loading', error: null })
    ),
    on(
        DeliveryAddressesActions.loadDeliveryAddressesSuccess,
        (state, { deliveryAddresses }): DeliveryAddressState => ({
            ...state,
            data: [...deliveryAddresses],
            status: 'success',
            error: null
        })
    ),
    on(
        DeliveryAddressesActions.loadDeliveryAddressesFailure,
        (state, { error }): DeliveryAddressState => ({ ...state, error, status: 'error' })
    ),
    on(
        DeliveryAddressesActions.createDeliveryAddress,
        (state): DeliveryAddressState => ({
            ...state,
            status: 'loading'
        })
    ),
    on(
        DeliveryAddressesActions.createDeliveryAddressSuccess,
        (state, { deliveryAddress }): DeliveryAddressState => ({
            ...state,
            data: [...(state.data || []), deliveryAddress],
            status: 'success'
        })
    ),
    on(
        DeliveryAddressesActions.createDeliveryAddressFailure,
        (state, { error }): DeliveryAddressState => ({
            ...state,
            status: 'error',
            error
        })
    )
);

export const deliveryAddressFeature = createFeature({
    name: DELIVERY_ADDRESS_FEATURE_KEY,
    reducer
});

export const {
    selectDeliveryAddressState,
    selectData: selectDeliveryAddresses,
    selectError,
    selectStatus
} = deliveryAddressFeature;

export const selectDeliveryAddressesLoading = createSelector(selectDeliveryAddressState, SelectorUtil.isLoading);
export const selectDeliveryAddressesDone = createSelector(selectDeliveryAddressState, SelectorUtil.isDone);

export const selectDefaultDeliveryAddress = createSelector(selectDeliveryAddresses, deliveryAddresses =>
    deliveryAddresses.find(e => e.default_flg)
);
